

import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { loginApi, refreshTokenApi } from "../../apis/authApi";

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  // Load user from sessionStorage on mount
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    setError(null);
    const toastId = toast.loading("Logging in... Please wait");

    try {
      const data = await loginApi(email, password);

      sessionStorage.setItem("accessToken", data.data.tokens.access);
      sessionStorage.setItem("refreshToken", data.data.tokens.refresh);
      sessionStorage.setItem("user", JSON.stringify(data.data.user));

      setCurrentUser(data.data.user); // 🔥 important

      toast.update(toastId, {
        render: "Login successful! Welcome back 🎉",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return data;
    } catch (err) {
      const msg =
        err.response?.data?.data ||
        "Login failed. Please check your credentials.";

      toast.update(toastId, {
        render: msg,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    sessionStorage.clear();
    setCurrentUser(null);
    toast.info("You have been logged out");
  };

  return {
    login,
    logout,
    loading,
    error,
    currentUser, // 👈 expose this
  };
};
